import React from "react";
import {
    Box,
} from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";

// Animation for bars
const barAnimation = keyframes`
  0%, 100% {
    transform: scaleY(0.3);
    opacity: 0.7;
  }
  50% {
    transform: scaleY(1);
    opacity: 1;
  }
`;

// Animation for chart pulse
const chartPulse = keyframes`
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
`;

const LoaderContainer = styled(Box)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    padding: "30px",
});

const ChartContainer = styled(Box)({
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    gap: "8px",
    height: "80px",
    padding: "10px 20px",
    backgroundColor: "rgba(22, 114, 222, 0.05)",
    borderRadius: "12px",
    border: "2px solid rgba(22, 114, 222, 0.1)",
    animation: `${chartPulse} 2s ease-in-out infinite`,
});

const Bar = styled(Box)(({ delay, height }) => ({
    width: "12px",
    height: `${height}%`,
    backgroundColor: "#1672DE",
    borderRadius: "6px 6px 0 0",
    animation: `${barAnimation} 1.2s ease-in-out infinite`,
    animationDelay: `${delay}s`,
    minHeight: "20px",
    boxShadow: "0 2px 8px rgba(22, 114, 222, 0.3)",
}));

const StatsContainer = styled(Box)({
    display: "flex",
    gap: "16px",
    marginTop: "10px",
});

const StatBox = styled(Box)(({ delay }) => ({
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    backgroundColor: "#1672DE",
    opacity: 0.7,
    animation: `${chartPulse} 1.5s ease-in-out infinite`,
    animationDelay: `${delay}s`,
    boxShadow: "0 2px 8px rgba(22, 114, 222, 0.2)",
}));

export const CustomLoader = () => {
    return (
        <LoaderContainer>
            <ChartContainer>
                <Bar delay={0} height={60} />
                <Bar delay={0.1} height={80} />
                <Bar delay={0.2} height={45} />
                <Bar delay={0.3} height={90} />
                <Bar delay={0.4} height={55} />
                <Bar delay={0.5} height={70} />
                <Bar delay={0.6} height={65} />
            </ChartContainer>
            <StatsContainer>
                <StatBox delay={0} />
                <StatBox delay={0.2} />
                <StatBox delay={0.4} />
            </StatsContainer>
        </LoaderContainer>
    );
}
